import { Box, useClipboard, useToast } from "@chakra-ui/react";
import React, { PropsWithChildren, useMemo } from "react";
import { formatStringForId, isDocPage } from "../services/URL";
import { useLocation } from "@reach/router";
import DownloadCenterLinkIcon from "../icons/DownloadCenterLinkIcon";

export default function JumpTo({
  id,
  children = null,
  skipFormat,
  offset = '-100px'
}: PropsWithChildren<{
  id: string;
  /**
   * Skips ID formatting. Set to true when the ID passed in is already formatted
   */
  skipFormat?: boolean;
  offset?: string;
}>) {
  const location = useLocation();

  const toast = useToast();

  const docPage = useMemo(() => isDocPage(location.pathname), [
    location.pathname,
  ]);

  const { onCopy } = useClipboard(
    `${location.origin}${location.pathname}#${id}`
  );

  const copy = () => {
    window.history.pushState(null, null, `#${id}`);
    onCopy();
    toast({
      title: "Link copied",
      status: "info",
      duration: 5000,
      isClosable: true,
      position: "bottom-left",
      variant: "apryse",
    });
  };

  return (
    <Box role="group" pos="relative" cursor="pointer" onClick={copy}>
      <Box
        id={skipFormat ? id : formatStringForId(id)}
        as="span"
        position="relative"
        top={docPage ? "-160px" : offset}
        pointerEvents="none"
        opacity={0}
      />

      {children !== null && (
        <DownloadCenterLinkIcon
          opacity={0}
          _groupHover={{
            opacity: 1,
          }}
          pos="absolute"
          left={0}
          top="50%"
          width="26px"
          height="326px"
          maxHeight="calc(100% + 3rem)"
          transform="translateY(-50%) translateX(-110%)"
          display='inline'
        />
      )}

      {children}
    </Box>
  );
}
